/* eslint-disable react/prop-types */
import cx from 'classnames';
import React from 'react';

import Center from '@zg-rentals/multibrand-ui/lib/Center';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Link from '@zg-rentals/multibrand-ui/lib/Link';

import StarRatingWithText from './StarRatingWithText';
import './style.scss';

class RateProperty extends React.Component {
  render() {
    const { propertyRating, onBack, onNext, defaultStarRating, onStarRatingClick, tenantType } = this.props;

    return (
      <div className="RateProperty">
        <Center>
          <Text type="body" className="stacked-xs">
            What was your impression of the property?
          </Text>
          <Text type="body-small" lowlight className="stacked-md">
            {`You’ll rate the property manager separately.`}
          </Text>
          <div className="stacked-lg">
            <StarRatingWithText defaultStarRating={defaultStarRating} onClick={onStarRatingClick} />
          </div>
          <div
            className={cx('RateProperty-nav', {
              'RateProperty-nav-centered': !tenantType,
            })}
          >
            {tenantType && (
              <Link type="secondary" onClick={onBack}>
                Back
              </Link>
            )}
            <Button type="primary" disabled={!propertyRating} onClick={onNext}>
              Next
            </Button>
          </div>
        </Center>
      </div>
    );
  }
}

RateProperty.defaultProps = {
  onStarRatingClick: () => {},
  onNext: () => {},
  propertyRating: null,
  tenantType: '',
};

export default RateProperty;
